import { ApolloClient } from '@apollo/client';
import { activityTotalsFragment } from '../../fragments/activityTotalsFragment';
import { buildQuery } from '../usePageQuery';

const POLL_INTERVAL = 2000;
const POLL_DURATION = 30000;
const MAX_POLL_COUNT = POLL_DURATION / POLL_INTERVAL;
const FRAGMENT = buildQuery(activityTotalsFragment);

let currentPollCount = 0;
let timer: unknown = null;

// Concurrency is handled in a pragmatic manner where it assumes the input paramenters
// are all the same for any subsequent calls. This may need to be updated if this code is
// used where mutiple pages will be sharing a single instance of this module (can't see
// a use case for this for a client side module).
export const updateActivityTotals = (
  client: ApolloClient<unknown>,
  pageType: string,
  pageSlug: string,
  isPreview: boolean,
) => {
  currentPollCount = 0;

  // Bail after resetting the retry count if we are already polling
  if (timer) return;

  const poll = async () => {
    if (currentPollCount >= MAX_POLL_COUNT) return;

    // The `network-only` fetch policy always grabs the latest data from the server and updates
    // the cache. Updating the cache results in any component using the `useQuery` hook
    // with the same query and variables to rerender with the latest data from the cache.
    await client.query({
      query: FRAGMENT,
      variables: {
        type: pageType.toUpperCase(),
        slug: pageSlug,
        preview: isPreview,
      },
      fetchPolicy: 'network-only',
    });

    timer = setTimeout(() => {
      timer = null;
      poll();
    }, POLL_INTERVAL);
    currentPollCount++;
  };

  poll();
};
